import React from 'react';
import {
  Bot,
  Disc3,
  Box,
  PartyPopper,
  Aperture,
  Tablet,
  Monitor,
  Package,
  Move,
  Camera,
  WandSparkles,
} from 'lucide-react';

import { NamedLink } from '../../../components/index.js';
import { BOOTH_TYPES } from '../landingPageData';
import css from './BoothTypes.module.css';

const ICONS = {
  Bot,
  Disc3,
  Box,
  PartyPopper,
  Aperture,
  Tablet,
  Monitor,
  Package,
  Move,
  Camera,
  WandSparkles,
};

const BoothTypes = () => {
  return (
    <section className={css.section} id="booth-types">
      <div className={css.container}>
        <div className={css.head}>
          <span className={css.overline}>In demand right now</span>
          <h2 className={css.title}>The booths & services hiring companies are requesting.</h2>
          <p className={css.sub}>
            From classic enclosed booths to camera robots and roaming photography. Here's the range
            of work showing up in RFPs across the marketplace.
          </p>
        </div>

        <div className={css.grid}>
          {BOOTH_TYPES.map(({ icon, label }) => {
            const Icon = ICONS[icon];
            return (
              <NamedLink key={label} name="SearchPage" className={css.booth}>
                <span className={css.boothIcon}>{Icon ? <Icon /> : null}</span>
                <span className={css.boothLabel}>{label}</span>
              </NamedLink>
            );
          })}
        </div>

        <p className={css.foot}>
          Don't see your specialty?{' '}
          <NamedLink name="SearchPage" className={css.footLink}>
            Browse every open RFP
          </NamedLink>{' '}
          in your service area.
        </p>
      </div>
    </section>
  );
};

export default BoothTypes;
